import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=52d5e236"
import script from "./ContentView.vue?vue&type=script&lang=js"
export * from "./ContentView.vue?vue&type=script&lang=js"
import style0 from "./ContentView.vue?vue&type=style&index=0&id=52d5e236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports